import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/manage_exchange_account',
  component: Layout,
  redirect: '/manage_exchange_account/index',
  name: 'ManageExchangeAccount',
  meta: {
    title: '交易所账号管理',
    i18n: 'route.tabbar',
    icon: 'i-ic:round-tab',
  },
  children: [
    {
      path: 'index',
      name: 'ManageExchangeAccountIndex',
      component: () => import('@/views/manage_exchange_account/index.vue'),
      meta: {
        title: '交易所账号管理',
        menu: false,
        breadcrumb: false,
        activeMenu: '/manage_exchange_account',
      },
    },
  ],
}

export default routes
